import React from "react";
import { motion } from "framer-motion";
import ingredientImage from "../assets/chepto1.png";
import { PiWarningBold, PiShieldCheckBold } from "react-icons/pi";

const IngredientsSection = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const scaleIn = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 1, ease: "easeOut" }
    }
  };

  const hoverCard = {
    rest: { scale: 1, boxShadow: "0px 0px 0px rgba(0,0,0,0)" },
    hover: {
      scale: 1.03,
      boxShadow: "0px 10px 25px rgba(0,0,0,0.15)",
      transition: { duration: 0.3 }
    }
  };

  const imageHover = {
    rest: { scale: 1, rotate: 0 },
    hover: {
      scale: 1.05,
      rotate: 1,
      transition: { duration: 0.4 }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-[12%]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            className="space-y-8"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            <motion.h2
              className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight cursor-pointer"
              variants={fadeInUp}
              whileHover={{ scale: 1.03, color: "#2563eb" }}
              transition={{ duration: 0.3 }}
            >
              Why SRIDANTH is
              <br />
              <span className="text-blue-600">The Safe Choice</span>
            </motion.h2>

            <motion.div
              className="space-y-6 text-lg text-gray-600 leading-relaxed"
              variants={fadeInUp}
              whileHover={{ scale: 1.02, color: "#1e293b" }}
              transition={{ duration: 0.3 }}
            >
              <p>
                Our commitment to safety means we
                <span className="font-semibold text-red-600"> avoid harmful ingredients </span>
                commonly found in other toothpastes, while using innovative formulas that repair,
                rebuild, and restore dental health.
              </p>
            </motion.div>

            <motion.div className="space-y-6" variants={fadeInUp}>
              <motion.div
                className="flex items-start gap-4 p-4 bg-red-50 rounded-xl border border-red-200 cursor-pointer"
                variants={hoverCard}
                initial="rest"
                whileHover="hover"
                animate="rest"
              >
                <div className="flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mt-1">
                  <PiWarningBold className="text-red-600 text-lg" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-red-800 mb-2">AVOID Titanium Dioxide</h3>
                  <ul className="text-red-700 space-y-1 text-sm">
                    <li>• Kills mouth & gut bacteria</li>
                    <li>• Causes genotoxicity</li>
                    <li>• Inhalation of Titanium Dioxide may be carcinogenic</li>
                  </ul>
                </div>
              </motion.div>

              <motion.div
                className="flex items-start gap-4 p-4 bg-orange-50 rounded-xl border border-orange-200 cursor-pointer"
                variants={hoverCard}
                initial="rest"
                whileHover="hover"
                animate="rest"
              >
                <div className="flex-shrink-0 w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mt-1">
                  <PiWarningBold className="text-orange-600 text-lg" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-orange-800 mb-2">AVOID Sodium Lauryl Sulfate</h3>
                  <ul className="text-orange-700 space-y-1 text-sm">
                    <li>• Causes dry mouth</li>
                    <li>• Leads to mouth irritation</li>
                    <li>• Can cause mouth ulcers</li>
                  </ul>
                </div>
              </motion.div>
            </motion.div>

            <motion.div
              className="inline-flex items-center gap-3 bg-gradient-to-r from-green-50 to-emerald-50 px-6 py-4 rounded-xl border border-green-200 cursor-pointer"
              variants={fadeInUp}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <div className="flex items-center justify-center w-10 h-10 bg-green-100 rounded-full">
                <PiShieldCheckBold className="text-green-600 text-xl" />
              </div>
              <div>
                <div className="text-lg font-bold text-green-700">SLS FREE TOOTHPASTE</div>
                <div className="text-sm font-medium text-green-600">Specially formulated for children's safety</div>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Image */}
          <motion.div
            className="relative flex items-center justify-center w-full rounded-3xl"
            initial="rest"
            whileHover="hover"
            animate="rest"
          >
            <motion.img
              src={ingredientImage}
              alt="SRIDANTH Safe Toothpaste Ingredients"
              className="w-full h-full object-cover rounded-3xl shadow-2xl cursor-pointer"
              variants={imageHover}
            />

            {/* <motion.div
              className="absolute top-6 left-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.5 }}
            >
              <span className="font-bold text-green-600 text-sm">REPAIR • REBUILD • RESTORE</span>
            </motion.div> */}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default IngredientsSection;
